export default __webpack_public_path__ + "static/media/new-logo.d779a3d5.png";